(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , festivalEventSchema = require('./festival-event-schema')
const required = require('@clocklimited/validity-required')

module.exports = function () {
  return schemata(
    { year:
      { type: Number
      , validators: { all: [ required ] }
      }
    , status:
      { type: String
      , validators:
        { all: [ required ]
        }
      , defaultValue: 'pending'
      }
    , capacity:
      { type: Number
      , validators:
        { all: [ required ]
        }
      }
    , startDate:
      { type: Date
      , validators: { all: [ required ] }
      }
    , endDate:
      { type: Date
      , validators: { all: [ required ] }
      }
    , events:
      { type: schemata.Array(festivalEventSchema)
      }
    , changelog:
      { type: Array
      }
    , lineup:
      { type: String
      }
    , notes:
      { type: String
      }
    , _city:
      { type: Array
      }
    , _country:
      { type: Array
      }
    , _keywords:
      { type: String
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/festival/festival-year-schema.js","/components/service/festival")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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